import React, { useState } from 'react';
import { LISTING_HEAP_IDS } from '../../_shared/constants';
import { Modal as LegacyEDSModal } from '@eventbrite/legacy-eds.modal';

import { Play, Cross } from '../../_shared/Icons';

import styles from './FeaturedHeroVideo.module.scss';

interface FeaturedHeroVideoProps {
  alt?: string;
  embedUrl: string;
  children?: React.ReactNode;
}

export const FeaturedHeroVideo: React.FC<FeaturedHeroVideoProps> = ({ alt, embedUrl, children }) => {
  const [shouldShowVideo, setShouldShowVideo] = useState(false);
  return (
    <>
      <div className={styles.root}>
        <div className={styles.overlay}>
          <button
            data-heap-id={LISTING_HEAP_IDS.HERO_VIDEO}
            className={styles.playButton}
            aria-label={'Play'}
            onClick={() => setShouldShowVideo(true)}
          >
            <div className={styles.playButtonIcon}>
              <Play />
            </div>
          </button>
        </div>
        {children}
      </div>
      {shouldShowVideo && (
        <LegacyEDSModal
          isShown={true}
          onClose={() => setShouldShowVideo(false)}
          noMinHeight={false}
          type="fullscreen"
          noPadding={true}
          closeButtonCustomIcon={(() => <Cross />) as unknown as React.ReactNode}
          closeButtonClassName={styles.closeButton}
          isClosable={true}
          isPortal={true}
          modalHostNodeSelector="body"
          dangerouslySetContainerClassName={{ __className: styles.modalContainer as string }}
          __containerClassName={styles.modal}
        >
          <div className={styles.modalVideoWrapper}>
            <iframe
              src={`${embedUrl.split('?')[0]}?autoplay=1&mute=1`}
              frameBorder="0"
              allowFullScreen
              allow="autoplay"
              title={alt || 'Video content'}
              loading="lazy"
            />
          </div>
        </LegacyEDSModal>
      )}
    </>
  );
};
